import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TargetIcon, UsersIcon, MessageSquareIcon } from 'lucide-react';
interface MentorHubTabsProps {
  userType: 'mentor' | 'mentee' | null;
  activeTab: 'goals' | 'matching' | 'messages';
  onTabChange: (tab: 'goals' | 'matching' | 'messages') => void;
}
const MentorHubTabs: React.FC<MentorHubTabsProps> = ({
  userType,
  activeTab,
  onTabChange
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabs = [{
    id: 'goals',
    label: 'Goals',
    icon: <TargetIcon size={18} data-id="element-193" />,
    path: '/mentor-hub/goals'
  }, {
    id: 'matching',
    label: userType === 'mentor' ? 'Mentees' : 'Match',
    icon: <UsersIcon size={18} data-id="element-194" />,
    path: '/mentor-hub/matching'
  }, {
    id: 'messages',
    label: 'Messages',
    icon: <MessageSquareIcon size={18} data-id="element-195" />,
    path: '/mentor-hub/messages'
  }];
  const handleTabClick = (tab: 'goals' | 'matching' | 'messages') => {
    onTabChange(tab);
    navigate(`/mentor-hub/${tab}`);
  };
  return <div className="bg-white bg-opacity-70 backdrop-blur mb-6 rounded-xl shadow-glass" data-id="element-196">
      <div className="flex p-1" data-id="element-197">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => handleTabClick(tab.id as 'goals' | 'matching' | 'messages')} className={`
                flex items-center py-3 px-6 relative rounded-lg transition-all duration-200
                ${isActive ? 'bg-purple-600 text-white shadow-sm' : 'text-purple-700 hover:bg-purple-50'}
              `} data-id="element-198">
              <div className="flex items-center" data-id="element-199">
                <span className={`mr-2 ${isActive ? 'text-white' : ''}`} data-id="element-200">
                  {tab.icon}
                </span>
                <span className="font-medium" data-id="element-201">{tab.label}</span>
              </div>
            </button>;
      })}
      </div>
    </div>;
};
export default MentorHubTabs;